import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { HttpClientModule } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { PickerModule } from '@ctrl/ngx-emoji-mart';

import { UserChatPanelComponent } from './components/user-chat-panel/user-chat-panel.component';
import { AdminChatPanelComponent } from './components/admin-chat-panel/admin-chat-panel.component';
import { UserChatListComponent } from './components/user-chat-list/user-chat-list.component';
import { UserChatDetailComponent } from './components/user-chat-detail/user-chat-detail.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FomanticUIModule,
    HttpClientModule,
    ScrollingModule,
    PickerModule,
  ],
  declarations: [
    UserChatPanelComponent,
    AdminChatPanelComponent,
    UserChatListComponent,
    UserChatDetailComponent,
  ],
  exports: [
    UserChatPanelComponent,
    AdminChatPanelComponent,
    UserChatListComponent,
    UserChatDetailComponent,
  ],
})
export class UiChatBotModule {}
